import { useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Question from './question.js';
import { getActiveQuestion } from '../redux/selectors.js';
import cx from 'classnames';

export default function Questions(){
	const questions = useSelector( s => s.questions );
	const activeQuestion = useSelector( getActiveQuestion );
	const dispatch = useDispatch();
	const questionsContainerRef = useRef( null );
	const [previousActiveQuestionIndex, setPreviousActiveQuestionIndex] = useState( activeQuestion.index );
	useEffect( () => {
		if ( questionsContainerRef.current ){
			if ( previousActiveQuestionIndex !== activeQuestion.index ){
				var topPos = window.jQuery(questionsContainerRef.current).offset().top;
				window.jQuery(window).scrollTo( topPos, {
					duration: 300
				} )
				setPreviousActiveQuestionIndex( activeQuestion.index );
			}
		}
	}, [activeQuestion.index, questionsContainerRef.current ]);
	return <div className="sr-questions" ref={ questionsContainerRef } >
		{ activeQuestion &&
			<Question { ...activeQuestion } />
		}
		{ questions.length > 1 &&
		<div className="pagination">
			<button className={ cx(
				"prev",
				"page-numbers"
			) }
				disabled={ activeQuestion.index === 0 } onClick={ e => {
				dispatch({
					type: 'set/activeQuestion',
					payload: activeQuestion.index - 1
				});
			}} >Previous</button>
			<div className="numbers-inner">
				{ questions.map( (q, i) => {
					return i === activeQuestion.index ?
						<span className="page-numbers current" key={ i } >{ i + 1 }</span>
						:
						<button className={ cx("page-numbers", "page-numbers-"+i) } key={ i } onClick={ e => {
							dispatch({
								type: 'set/activeQuestion',
								payload: i
							});
						}}>{i + 1}</button>
				} ) }
			</div>
			<button
				className="next page-numbers"
				disabled={ activeQuestion.index >= (questions.length - 1) } 
				onClick={ e => {
				dispatch({
					type: 'set/activeQuestion',
					payload: activeQuestion.index + 1
				});
			}} >Next</button>
		</div>
		}
	</div>
	return <ol className="sr-questions">
		{ questions.map( (question, i) => {
			return <Question {...question} index={ i } key={ i } />
		}) }
	</ol>
}